module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-upload-container"
  }, [_c('div', {
    staticClass: "label-box"
  }, [(_vm.label) ? _c('div', {
    staticClass: "label-item"
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.label || ' '))])]) : _vm._e(), _vm._v(" "), (
    !_vm.disabled &&
    _vm.localFileList.length !== 0 &&
    _vm.localFileList.length < _vm.limit
  ) ? _c('SingleUpload', {
    staticClass: "upload-item",
    attrs: {
      "action": _vm.action,
      "multiple": false,
      "accept": _vm.accept,
      "maxFileSize": _vm.maxFileSize,
      "disabled": _vm.disabled || _vm.fileList.length == 0,
      "autoUpload": _vm.autoUpload,
      "params": _vm.params,
      "change": _vm.onChange,
      "success": _vm.onSuccess,
      "error": _vm.onError,
      "beforeUpload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "gsk-icon-clip",
    staticStyle: {
      "font-size": "16px",
      "color": "#000"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-add-text"
  }, [_vm._v(_vm._s(_vm.$t('btn.add')))])]) : _vm._e()], 1), _vm._v(" "), (_vm.subLabel) ? _c('div', {
    staticClass: "label-item",
    staticStyle: {
      "font-size": "12px",
      "white-space": "normal",
      "color": "#666",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.subLabel || ' '))])]) : _vm._e(), _vm._v(" "), (_vm.localFileList.length != 0) ? _c('div', {
    staticClass: "file-box"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckFile
    },
    model: {
      value: (_vm.checkedFilesList),
      callback: function($$v) {
        _vm.checkedFilesList = $$v
      },
      expression: "checkedFilesList"
    }
  }, [_vm._l((_vm.forEachFileList), function(lineFileList, lineIndex) {
    return [_c('div', {
      key: lineIndex,
      staticClass: "line-file-box"
    }, [_vm._l((lineFileList), function(file, fileIndex) {
      return [(_vm.select) ? _c('el-checkbox', {
        key: fileIndex,
        class: {
          'empty-file-item': !(file.name || file.fileName)
        },
        attrs: {
          "label": typeof file.id == 'object' ? file.id.id : file.id,
          "disabled": file.disableCheck
        }
      }) : _vm._e(), _vm._v(" "), (!(file.name || file.fileName) && _vm.select) ? _c('div', {
        key: fileIndex,
        staticStyle: {
          "width": "24px"
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        key: fileIndex,
        staticClass: "file-item",
        class: {
          'empty-file-item': !(file.name || file.fileName)
        }
      }, [(file.fileName || file.name) ? [_c('div', {
        staticClass: "file-type-box"
      }, [_c('i', {
        class: _vm.icon || _vm.getIconByFileName(file),
        style: (_vm.preview ?
          'font-size: 40px;cursor: pointer;' :
          'font-size: 40px;'),
        on: {
          "click": function($event) {
            _vm.preview ? _vm.previewFile(file) : function () {}
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "file-action-box"
      }, [_c('div', {
        staticClass: "line",
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [_c('span', {
        staticClass: "line-file-name",
        attrs: {
          "title": file.name || file.fileName
        },
        on: {
          "click": function($event) {
            _vm.preview ? _vm.previewFile(file) : function () {}
          }
        }
      }, [_vm._v(_vm._s(file.name || file.fileName))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.disabledDelete && _vm.allowDelete(file)),
          expression: "!disabledDelete && allowDelete(file)"
        }],
        staticClass: "line-file-delete",
        on: {
          "click": function($event) {
            return _vm.delFile(file)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('btn.delete')))])]), _vm._v(" "), _c('div', {
        staticClass: "line",
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [_c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [_c('span', [_vm._v(_vm._s(_vm._f("FileSizeFormat")((file.size || file.fileSize))))]), _vm._v(" "), (_vm.showDate) ? _c('span', {
        staticStyle: {
          "margin-left": "5px"
        },
        domProps: {
          "textContent": _vm._s(_vm.showDatePage(file))
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [(_vm.preview) ? _c('span', {
        staticClass: "line-file-preview",
        on: {
          "click": function($event) {
            return _vm.previewFile(file)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('btn.preview')))]) : _vm._e(), _vm._v(" "), (_vm.download) ? _c('span', {
        staticClass: "line-file-download",
        on: {
          "click": function($event) {
            return _vm.downloadFile(file)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('btn.download')))]) : _vm._e()])])])] : _vm._e()], 2)]
    })], 2)]
  })], 2)], 1) : _c('div', {
    staticClass: "empty-box"
  }, [_c('NoDataFound', [_c('div', {
    staticClass: "empty-upload",
    staticStyle: {
      "font-size": "14px",
      "color": "#999",
      "text-align": "center"
    }
  }, [(!_vm.disabled) ? _c('SingleUpload', {
    attrs: {
      "action": _vm.action,
      "multiple": false,
      "accept": _vm.accept,
      "maxFileSize": _vm.maxFileSize,
      "disabled": _vm.disabled,
      "autoUpload": _vm.autoUpload,
      "params": _vm.params,
      "change": _vm.onChange,
      "success": _vm.onSuccess,
      "error": _vm.onError,
      "beforeUpload": _vm.beforeUpload
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$languageChoose({
    en: 'Only support ' +
      (_vm.forEachAccept || 'files') +
      ' within ' +
      _vm.maxFileSize +
      'M,',
    zh: '仅支持' + _vm.maxFileSize + 'M内的' + _vm.forEachAccept + '文件，'
  })))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#f36633"
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.add')))])]) : _vm._e()], 1)])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7db47407", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7db47407","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upload/FileBox.vue
// module id = 1591
// module chunks = 7